import { ArcConnectionsControls } from "./ArcConnectionsControls";

export function ArcConnectionsPanel() {
    return <ArcConnectionsControls />;
}

